var KeyboardKey;
(function (KeyboardKey) {
    KeyboardKey["Escape"] = "Escape";
    KeyboardKey["Tab"] = "Tab";
})(KeyboardKey || (KeyboardKey = {}));

export { KeyboardKey };
